import { Skeleton } from 'antd';

import './profileSkeleton.scss';

export const ProfileSkeleton = () => {
    return (
        <div className="skeleton-container">
            <Skeleton.Avatar shape="square" className="skeleton-avatar-custom" active />
            <div className="skeleton-content">
                <Skeleton.Input className="skeleton-input" active />
                <Skeleton.Input className="skeleton-input" active />
                <Skeleton.Input className="skeleton-input" active />
                <Skeleton.Input className="skeleton-input" active />
            </div>
        </div>
    );
};
